import Vue from 'vue'
import Dayjs from 'dayjs'

export default Vue.extend({
  template: `
      <b-datepicker
        ref="date"
        v-model="date"
        placeholder="Date"
        icon="calendar-today"
        editable
        position="is-bottom-left"
        class="ag-input-field-input ag-text-field-input"
      />
  `,
  mounted () {
    this.date = new Date(this.params.value)
    this.$nextTick(() => this.$refs.date.toggle())
  },
  methods: {
    getValue () {
      let dateFormat = this.params.colDef.dateFormat
      if (!_.isEmpty(dateFormat)) {
        return Dayjs(this.date).format(dateFormat)
      } else {
        return Dayjs(this.date).format('YYYY-MM-DD')
      }
    },
    setValue () {
      console.log('setValue')
    },
    isPopup () {
      return true
    },
    cellStartedEdit () {
      return true
    }
  },
  data: function () {
    return {
      date: null
    }
  }
})
